module.exports = __webpack_public_path__ + "static/media/help-icon.90a3ab4a.svg";